import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import { ControlContainer } from '../../../FormField/components/ControlContainer/ControlContainer.js';
import { Input } from '../../../FormField/components/Input/Input.js';
import { Root } from '../../../FormField/components/Root/Root.js';
import { useSelectSearchField } from './hooks/useSelectSearchField.js';

var SelectSearchField = /*#__PURE__*/React.memo(function (props) {
  var _useSelectSearchField = useSelectSearchField(props),
    inputRef = _useSelectSearchField.inputRef,
    rootProps = _useSelectSearchField.rootProps,
    inputProps = _useSelectSearchField.inputProps,
    controlContainerProps = _useSelectSearchField.controlContainerProps;
  return /*#__PURE__*/React.createElement(Root, rootProps, /*#__PURE__*/React.createElement(ControlContainer, controlContainerProps, /*#__PURE__*/React.createElement(Input, _extends({
    ref: inputRef
  }, inputProps))));
});

export { SelectSearchField };
//# sourceMappingURL=SelectSearchField.js.map
